import React, { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import "./index.css";


const DateCellEditor = forwardRef((props, ref) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => inputRef.current?.value || '',
    isCancelAfterEnd: () => false,
  }));

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return '';
    const date = new Date(dateValue);
    return date.toISOString().split('T')[0];
  };

  return (
    <input
      ref={inputRef}
      type="date"
      defaultValue={formatDateForInput(props.value)}
      style={{
        width: '100%',
        height: '100%',
        border: '1px solid #007bff',
        padding: '4px',
        fontSize: '14px',
      }}
    />
  );
});

export default DateCellEditor;
